import React from 'react'
import { injectState } from 'freactal'

const shortName = {
  performanceCriteria: 'PC',
  performanceEvidence: 'PE',
  knowledgeEvidence: 'KE',
}

const Level1Element = ({
  unit,
  type,
  showType,
  element,
  index,
  ...restProps
}) => {
  const { text, items = [] } =
    element || unit[type][index] || unit[type][index[0]] || {text: 'MISSING'}
  return (
    <div {...restProps}>
      <span>
        {type &&
          showType &&
          <b>
            {shortName[type]}
          </b>}{' '}
        {text}
      </span>
      {items.length > 0 &&
        <ul>
          {items.map(({ text, items = [] }, i) =>
            <li key={i}>
              {text}
              {items.length > 0 &&
                <ul>
                  {items.map((text, i) =>
                    <li key={i}>
                      {text}
                    </li>,
                  )}
                </ul>}
            </li>,
          )}
        </ul>}
    </div>
  )
}

const Level2Element = ({ unit, type, index }) =>
  <ul>
    <li>
      {unit[type][index[0]] && unit[type][index[0]].items[index[1]] 
        ?
        unit[type][index[0]].items[index[1]].text
        : 'MISSING'
      }
    </li>
  </ul>

const Level3Element = ({ unit, type, index }) =>
  <ul style={{ listStyle: 'none' }}>
    <li>
      <ul>
        <li>
          {unit[type][index[0]].items[index[1]].items[index[2]]}
        </li>
      </ul>
    </li>
  </ul>

function UnitElement({
  state: { unit },
  effects, // eslint-disable-line
  element,
  type,
  index,
  showType = true,
  ...restProps
}) {
  const Component =
    !Array.isArray(index) || index.length === 1
      ? Level1Element
      : index.length === 2 ? Level2Element : Level3Element
  return (
    <Component
      unit={unit}
      type={type}
      showType={showType}
      element={element}
      index={index}
      {...restProps}
    />
  )
}

export default injectState(UnitElement)



// WEBPACK FOOTER //
// ./src/Units/components/UnitElement.js